import * as action from 'actions'
import * as actOutlet from 'actions/outlet'
import * as auth from 'api/auth'
import {take, call, put, fork} from 'redux-saga/effects'
import {browserHistory} from 'react-router'
import {getProfile} from 'sagas/api/profile'

import {
  OUTLETS_REQUEST,
  GET_CURRENT_OUTLET_REQUEST
} from 'actions/outlet/constants'

export function * outlets () {
  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())

  try {
    let response = yield call(auth.outlets)
    return response.data
  } catch (error) {
    if (error.status === 401) {
      yield put(action.setAuthState(false))
      browserHistory.push('/login')
    } else {
      let eobj = new Error(error.message)
      yield put(action.requestError(eobj))
    }
    return false
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.hideProgressBar())
  }
}

export function * loadOutletsFlow () {
  while (true) {
    yield take(OUTLETS_REQUEST)
    const outletsData = yield call(outlets)
    if (outletsData) {
      yield put(actOutlet.setOutlets(outletsData))
    }
  }
}

export function * getCurrentOutletFlow () {
  // noinspection InfiniteLoopJS
  while (true) {
    yield take(GET_CURRENT_OUTLET_REQUEST)
    const currentOutlet = yield call(getProfile)
    if (currentOutlet) {
      yield put(actOutlet.setCurrentOutlet(currentOutlet))
    }
  }
}

export default function * outletSaga () {
  yield fork(loadOutletsFlow)
  yield fork(getCurrentOutletFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/outlet.js